import React from "react";
import { Car, Truck } from "lucide-react";
import { useBooking } from "../../context";

const VehicleSelector = () => {
  const { vehicleType, setVehicleType } = useBooking();

  const vehicles = [
    { id: "small", label: "Small Car", icon: Car },
    { id: "medium", label: "SUV / Med", icon: Car },
    { id: "large", label: "Large / Van", icon: Truck },
    { id: "xl", label: "XL / Truck", icon: Truck }
  ];

  return (
    <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-8" data-testid="vehicle-selector">
      {vehicles.map((v) => (
        <button
          key={v.id}
          onClick={() => setVehicleType(v.id)}
          className={`vehicle-selector-btn flex items-center gap-2 px-4 py-3 rounded-full font-medium transition-all ${
            vehicleType === v.id ? "active" : ""
          }`}
          data-testid={`vehicle-${v.id}-btn`}
        >
          <v.icon className="w-5 h-5" />
          <span className="hidden sm:inline">{v.label}</span>
          <span className="sm:hidden">{v.id === "medium" ? "SUV" : v.id === "large" ? "Van" : v.id === "xl" ? "XL" : "Small"}</span>
        </button>
      ))}
    </div>
  );
};

export default VehicleSelector;
